// @flow
import constants from './constants';

const getApiEndpoint = ({ surveyId }: { surveyId: string } = {}) => {
  if (surveyId === undefined || surveyId === '') {
    throw new Error('arg `surveyId` is missing');
  }
  return `${constants.SURVEY_API_ENDPOINT_BASE}${surveyId}`;
};

export default getApiEndpoint;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/getApiEndpoint.js